import axios from "axios";

const headers = { "Content-Type": "application/json" };
if (localStorage.getItem('child_token')) {
  headers.Authorization = localStorage.getItem('child_token');
}
export default axios.create({
  baseURL: process.env.VUE_APP_CHILD_API_URL,
  headers: headers
});